<template>
	<div class="control">
		<div class="form-group floating">
			<label class="placeholder-label" for="app-search-input">{{ control.placeholder }}</label>
			<input id="app-search-input" @focus="containerFocus" @blur="containerBlur" class="form-control" v-bind:class="className" :autocomplete="autocomplete" type="text" v-model="query" v-on:keyup.enter="updateFilters" v-on:change="updateChange" />
			<label class="sr-only" for="app-search-input">Search</label>

			<button type="button" v-if="query" title="Clear" v-on:click="clearSearchTerm()" class="fas fa-times-circle search-clear"></button>
			<button type="button" v-if="control.searchButton" 
				v-bind:disabled="query == undefined || query.length == 0"
				v-on:click="updateFilters">
				<span class="sr-only">search</span><i class="fas fa-search"></i>
			</button>			
		</div>
	</div>
</template>

<script>
    import he from 'he';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'className', 'parent', 'autocomplete'],
		data: function () {
			return {
				query: he.decode(this.parent.defaultValue),
            }
		},
		computed: {
			...mapState({
				spec: state => state.listing.specification,
			}),
		},
		watch: {
			spec: {
				handler(value) {
					if (value[this.control.specification] !== '' && value[this.control.specification] !== null) {
						this.query = value[this.control.specification];
					}
				},
				immediate: true,
				deep: true,
			}
		},
        mounted: function () {
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.query = this.control.defaultValue;
				}
			});
			var inp = $('#app-search-input')
			console.log(inp);
			if (inp.length > 0) {
				if ($(inp).val() !== '') {
					console.log($(inp).val());
					$('.floating').addClass('has-focus');
					$('.floating').addClass('is-floating');
				} else {
                    $('.floating').addClass('no-label');
				}
			}
		},
		methods: {
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			clearSearchTerm() {
				console.log('clearSearchTerm');
				if (this.query !== '') {
					this.query = '';
					this.updateFilters();
				}
			},
			containerFocus(e) {
				const target = e.currentTarget;
				if ($(target).val() === '') {
					$('.floating').addClass('has-focus');
					$('.floating').addClass('is-floating');
				} else {
					$('.floating').addClass('no-label');
				}
			},
			containerBlur(e) {
				const target = e.currentTarget;
				if ($(target).val() === '') {
					$('.floating').removeClass('has-focus');
					$('.floating').removeClass('is-floating');
				} else {
					$('.floating').removeClass('no-label');
				}
			},
			updateChange() {
				this.updateFilters();
			},

			removeWhiteSpaces(str) {
				return str.replace(/\s+/g, '');
			},

            updateFilters() {
				console.log('updateFilters');
				this.updateSpecification({ key: this.control.specification, value: he.decode(this.query) });
			},
		}
	}
</script>